class MiniCart extends HTMLElement {
  constructor() {
    super();
    this.cartTimerDuration = 300; // 5 minutes in seconds
    this.remainingTime = this.cartTimerDuration;
    this.timerInterval = null;
    this.timerTextElement = null;
    this.hasExpired = false; // flag to track if countdown reached 0
  }

  connectedCallback() {
    this.header = document.querySelector("sticky-header");
    this.drawer = document.querySelector("cart-drawer");

    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);

    document.addEventListener(
      "cartdrawer:opened",
      this.handleCartOpen.bind(this)
    );
    document.addEventListener(
      "cartdrawer:closed",
      this.handleCartClose.bind(this)
    );

    this.startCartTimer(); // Start countdown immediately in background
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        document.getElementById("mini-cart").innerHTML =
          this.getSectionInnerHTML(html, ".shopify-section");

        document.dispatchEvent(new CustomEvent("cartdrawer:opened"));
      })
      .catch((e) => console.error(e));
  }

  open() {
    const detailsElement = this.drawer.querySelector("details");
    if (!detailsElement.hasAttribute("open")) {
      this?.drawer?.openMenuDrawer();
      this.handleCartOpen();
    }
  }

  handleCartOpen() {
    this.timerTextElement = this.querySelector(".cart-timer-text");

    if (this.hasExpired) {
      this.resetCartTimer(); // resets time and starts fresh timer
      this.hasExpired = false;
    } else {
      this.startCartTimer(); // start only if not already running
    }

    if (this.timerTextElement) {
      this.updateTimerText();
    }
  }

  handleCartClose() {
    this.timerTextElement = null; // Stop UI updates (but timer continues)
    document.body.classList.remove("mini-cart--open");
  }

  startCartTimer() {
    if (this.timerInterval) return; // Avoid multiple intervals

    this.timerInterval = setInterval(() => {
      if (this.timerTextElement) {
        this.updateTimerText();
      }

      if (this.remainingTime <= 0) {
        this.closeCartDrawer();
        this.stopCartTimer();
        this.hasExpired = true;
        return;
      }

      this.remainingTime--;
    }, 1000);
  }

  stopCartTimer() {
    clearInterval(this.timerInterval);
    this.timerInterval = null;
  }

  resetCartTimer() {
    this.remainingTime = this.cartTimerDuration;
    if (!this.timerInterval) {
      this.startCartTimer(); // Restart if not already running
    }
  }

  updateTimerText() {
    const minutes = String(Math.floor(this.remainingTime / 60)).padStart(
      2,
      "0"
    );
    const seconds = String(this.remainingTime % 60).padStart(2, "0");
    this.timerTextElement.textContent = `🚨 Your cart will expire in ${minutes}:${seconds} minutes 🚨`;
  }

  closeCartDrawer() {
    const details = this.drawer?.querySelector("details");
    if (details?.hasAttribute("open")) {
      details.removeAttribute("open");
      document.dispatchEvent(new CustomEvent("cartdrawer:closed"));
    }
    this.hasExpired = true;
    console.log(this.hasExpired);
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const el = document.getElementById(section.id);
      if (el) {
        el.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "mini-cart",
        section: "mini-cart",
        selector: ".shopify-section",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "mobile-cart-icon-bubble",
        section: "mobile-cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
}

customElements.define("mini-cart", MiniCart);
